import MainShape from './MainShapes.js';

export default class Relation extends MainShape {
  constructor(id, name, position) {
    super(id, name, 'Relation', position);
  }
}
